import React from "react";
import { Container, Row } from "reactstrap";
// import RolesTable from "./components/RolesTable";
import PageHeader from "../../../shared/components/PageHeader";
import RoleTable from "./components/RoleTable";

const RolesList = () => (
  <Container>
    <PageHeader header="Manage Roles" subheader="View Roles Information" />
    <Row>
      <RoleTable />
    </Row>
  </Container>
);

export default RolesList;
